enum ContractRefundStatusCode {
  OPEN = 'OPEN',
  PROCESSING = 'PROCESSING',
  APPROVED = 'APPROVED',
  PAYMENT_PENDING = 'PAYMENT_PENDING',
  PAID = 'PAID',
  PAID_NOREFUND = 'PAID_NOREFUND',
  CANCELLED = 'CANCELLED',
}

export default ContractRefundStatusCode;
export type VerifyContractRefundStatusCode = Utils.VerifyExtends<
  Model.Enum.ContractRefundStatusCode,
  Utils.ValueOf<typeof ContractRefundStatusCode>
>;
